// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.no-border select {
  background-color: #111;
  color: #fff !important;
  border: 1px solid #fff;
  border-radius: 10px;
  padding: 4px;
}

select {
  -webkit-appearance: none !important;
}

.auth select {
  background-color: #fff !important;
  border: #fff !important;
  border-radius: 31px !important;
  width: 114px !important;
  height: 40px !important;
  /* padding-left: 20px !important; */
}

.nav select {
  background-color: #111;
  color: white;
  border: 1px solid white;
  border-radius: 30px;
  width: 100px;
  height: 40px !important;
  outline: none !important;
  padding: 10px!important; 
}`, "",{"version":3,"sources":["webpack://./src/app/shared/components/language-switch/language-switch.component.css"],"names":[],"mappings":"AAAA;EACE,sBAAsB;EACtB,sBAAsB;EACtB,sBAAsB;EACtB,mBAAmB;EACnB,YAAY;AACd;;AAEA;EACE,mCAAmC;AACrC;;AAEA;EACE,iCAAiC;EACjC,uBAAuB;EACvB,8BAA8B;EAC9B,uBAAuB;EACvB,uBAAuB;EACvB,mCAAmC;AACrC;;AAEA;EACE,sBAAsB;EACtB,YAAY;EACZ,uBAAuB;EACvB,mBAAmB;EACnB,YAAY;EACZ,uBAAuB;EACvB,wBAAwB;EACxB,uBAAuB;AACzB","sourcesContent":[".no-border select {\n  background-color: #111;\n  color: #fff !important;\n  border: 1px solid #fff;\n  border-radius: 10px;\n  padding: 4px;\n}\n\nselect {\n  -webkit-appearance: none !important;\n}\n\n.auth select {\n  background-color: #fff !important;\n  border: #fff !important;\n  border-radius: 31px !important;\n  width: 114px !important;\n  height: 40px !important;\n  /* padding-left: 20px !important; */\n}\n\n.nav select {\n  background-color: #111;\n  color: white;\n  border: 1px solid white;\n  border-radius: 30px;\n  width: 100px;\n  height: 40px !important;\n  outline: none !important;\n  padding: 10px!important; \n}"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
